import Presentation from "./presentation";

const component = ( {
	enabledState,
	settingsName,
	title,
	updateNotificationStates
} ) => {

	return (
		<Presentation
			enabledState             = { enabledState }
			settingsName             = { settingsName }
			title                    = { title }
			updateNotificationStates = { updateNotificationStates }
		/>
	);
};

export default component;